import { AuthRequest } from "../utils";

const cache = new Map();


export function fetchData(url, devData, args) {
    !cache.has(url) && cache.set(url, getData(url, devData, args));

    return cache.get(url);
}


async function getData(url, devData, args) {
    if (devData) {
        // add fake delay
        await new Promise(res => setTimeout(res, 1500))
        return devData
    }

    return await AuthRequest(url, args);

}